import { render, staticRenderFns } from "./SelectTaxonomy.vue?vue&type=template&id=31a21b6a&"
import script from "./SelectTaxonomy.vue?vue&type=script&lang=ts&"
export * from "./SelectTaxonomy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports